import { Package, Store, Tag, ShoppingBag } from 'lucide-react';
import type { LandingData } from '@/types';

interface TrustBarProps {
  data: Pick<LandingData, 'categories' | 'bestSellers' | 'campaigns' | 'topWholesalers'>;
}

export function TrustBar({ data }: TrustBarProps) {
  const totalOrders = data.topWholesalers.reduce((sum, w) => sum + (w.orderCount ?? 0), 0);

  const stats = [
    {
      icon: Store,
      value: `${data.topWholesalers.length || '—'}+`,
      label: 'Güvenilir Toptancı',
    },
    {
      icon: Package,
      value: `${data.bestSellers.length || '—'}+`,
      label: 'Popüler Ürün',
    },
    {
      icon: Tag,
      value: `${data.campaigns.length || '—'}`,
      label: 'Aktif Kampanya',
    },
    {
      icon: ShoppingBag,
      value: totalOrders > 0 ? `${totalOrders}+` : '—',
      label: 'Tamamlanan Sipariş',
    },
  ];

  return (
    <section className="border-y border-slate-200 bg-white">
      <div className="section-container py-8 md:py-10">
        <div className="grid grid-cols-2 gap-6 md:grid-cols-4 md:gap-8">
          {stats.map((stat) => {
            const Icon = stat.icon;
            return (
              <div key={stat.label} className="flex items-center gap-4">
                <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-slate-100">
                  <Icon className="h-5 w-5 text-slate-700" strokeWidth={1.75} />
                </div>
                <div>
                  <p className="text-2xl font-bold text-slate-900">{stat.value}</p>
                  <p className="text-sm text-slate-600">{stat.label}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
